export default __webpack_public_path__ + "static/bg-app--mobile-349e7e49228793dc053e672ede0463e9.webp";